import { mixValue } from '@/app/lcv/components/sections/spartan/home/engine/utils';

export const ENGINE_VIDEO_RESOLUTION = { width: 1920, height: 1080 };

export interface EngineFrame {
  x: number;
  y: number;
  size: number;
}

// Tuning
export const ENGINE_INTRO_FRAME: EngineFrame = { x: 490, y: 60, size: 981 };
export const ENGINE_STORY_FRAME: EngineFrame = { x: 350, y: 20, size: 1280 };

export const ENGINE_SETTLE_SECONDS = 2;
export const ENGINE_SETTLE_DELAY_SECONDS = 0.5;
export const ENGINE_SETTLE_EASE: [number, number, number, number] = [
  0.32, 0.72, 0, 1,
];

export interface EngineFrameOffset {
  x: number;
  y: number;
  scale: number;
}

export const getEngineFrameOffset = (
  video: DOMRect,
  slot: DOMRect,
  frame: EngineFrame
): EngineFrameOffset => {
  const cover = Math.max(
    video.width / ENGINE_VIDEO_RESOLUTION.width,
    video.height / ENGINE_VIDEO_RESOLUTION.height
  );
  const frameX =
    video.left + (video.width - ENGINE_VIDEO_RESOLUTION.width * cover) / 2;
  const frameY =
    video.top + (video.height - ENGINE_VIDEO_RESOLUTION.height * cover) / 2;

  return {
    x: frameX + frame.x * cover - slot.left,
    y: frameY + frame.y * cover - slot.top,
    scale: slot.width > 0 ? (frame.size * cover) / slot.width : 1,
  };
};

export const applyEngineFrameOffset = (
  engine: HTMLElement,
  from: EngineFrameOffset,
  t: number
) => {
  engine.style.translate = `${mixValue(from.x, 0, t)}px ${mixValue(from.y, 0, t)}px`;
  engine.style.scale = `${mixValue(from.scale, 1, t)}`;
};
